import React from 'react';
import { TableLevelAction } from '../../../common';
import { Grid,Tooltip,IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/reducers';
import {
    DoneAll,
    RemoveDone,
    Visibility,
    VisibilityOff,
} from "@mui/icons-material";

export const GridLevelActions = ({
    loading,
    handleAction,
    handleRefresh,
}) => {
     const selectedNotifications = useSelector(
            (state: RootState) =>
                state.pagesV2["all-notifications-landing"].selected
    );
    
    return (
        <TableLevelAction
            handleRefresh={handleRefresh}
            actions={() => (
                <>
                    <Grid item>
                        <Tooltip
                            title={
                                selectedNotifications.length == 0
                                    ? "Select At least 1 for marking as Read"
                                    : "Mark Selected as Read"
                            }
                        >
                            <span>
                                <IconButton
                                    size="small"
                                    onClick={() =>
                                        handleAction(
                                            "read",
                                            selectedNotifications
                                        )
                                    }
                                    disabled={
                                        loading ||
                                        selectedNotifications.length === 0
                                    }
                                >
                                    <Visibility />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <Tooltip
                            title={
                                selectedNotifications.length == 0
                                    ? "Select At least 1 for marking as Unread"
                                    : "Mark Selected as Unread"
                            }
                        >
                            <span>
                                <IconButton
                                    size="small"
                                    onClick={() =>
                                        handleAction(
                                            "unread",
                                            selectedNotifications
                                        )
                                    }
                                    disabled={
                                        loading ||
                                        selectedNotifications.length === 0
                                    }
                                >
                                    <VisibilityOff />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <Tooltip title="Mark All as Read">
                            <IconButton
                                size="small"
                                onClick={() => handleAction("allRead", [])}
                                disabled={loading}
                            >
                                <DoneAll />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <Tooltip title="Mark All as Unread">
                            <IconButton
                                size="small"
                                onClick={() => handleAction("allUnread", [])}
                                disabled={loading}
                            >
                                <RemoveDone />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </>
            )}
            loading={loading}
        />
    );
};
;